/** Normalize DB/UI status strings to snake_case key. */
export function normalizeSubProjectStatus(status) {
  return String(status || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
}

const LABELS = {
  draft: "Draft",
  planning: "Planning",
  waiting_planning: "Waiting Planning",
  to_do: "To Do",
  ready_to_test: "Ready To Test",
  in_progress: "In Progress",
  developing: "Developing",
  developing_qa: "Developing QA",
  qa_processing: "QA Processing",
  ready_to_test_sit: "Ready To Test on SIT",
  testing_on_sit: "Testing on SIT",
  ready_to_test_stg: "Ready To Test on STG",
  testing_on_stg: "Testing on STG",
  waiting_to_deploy: "Waiting To Deploy",
  ready_to_deploy: "Ready To Deploy",
  done: "Done",
  done_without_deploy: "Done without Deploy",
  deployed: "Deployed",
  testing: "Testing",
  bug: "Bug",
  block: "Blocked",
  blocked: "Blocked",
  hold: "Hold",
  cancel: "Cancel",
  waiting_information: "Waiting Information",
  waiting_support: "Waiting Support",
  on_hold: "Hold",
  completed: "Done",
  cancelled: "Cancel",
};

const PILL_CLASS = {
  draft: "pill-draft",
  planning: "pill-planning",
  waiting_planning: "pill-waiting-planning",
  to_do: "pill-todo",
  ready_to_test: "pill-todo",
  in_progress: "pill-inprogress",
  developing: "pill-inprogress",
  developing_qa: "pill-inprogress",
  qa_processing: "pill-inprogress",
  ready_to_test_sit: "pill-readytest-sit",
  testing_on_sit: "pill-readytest-sit",
  ready_to_test_stg: "pill-readytest-stg",
  testing_on_stg: "pill-readytest-stg",
  waiting_to_deploy: "pill-waiting-deploy",
  ready_to_deploy: "pill-ready-deploy",
  done: "pill-done",
  done_without_deploy: "pill-done-without-deploy",
  deployed: "pill-deployed",
  testing: "pill-testing",
  bug: "pill-bug",
  block: "pill-blocked",
  blocked: "pill-blocked",
  hold: "pill-hold",
  cancel: "pill-cancel",
  waiting_information: "pill-waiting-information",
  waiting_support: "pill-waiting-support",
  on_hold: "pill-hold",
  completed: "pill-done",
  cancelled: "pill-cancel",
};

export function subProjectStatusLabel(status) {
  const key = normalizeSubProjectStatus(status);
  if (!key) return "—";
  if (LABELS[key]) return LABELS[key];
  return key
    .split("_")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

export function subProjectStatusPillClass(status) {
  const key = normalizeSubProjectStatus(status);
  return PILL_CLASS[key] || "pill-inactive";
}

/** Aliases for shared use across views */
export const statusLabel = subProjectStatusLabel;
export const statusPillClass = subProjectStatusPillClass;

const PLAN_HISTORY_STATUSES = new Set(["deployed", "done_without_deploy"]);

/** Plan / test-run HISTORY tabs: closed without staying on the team board. */
export function isPlanHistoryStatus(status) {
  return PLAN_HISTORY_STATUSES.has(normalizeSubProjectStatus(status));
}

/** True when value looks like a workflow status key (snake_case). */
export function isWorkflowStatusKey(status) {
  const key = normalizeSubProjectStatus(status);
  return !!key && (key.includes("_") || Object.prototype.hasOwnProperty.call(LABELS, key));
}

/** Options for Plan Management — test plan list create/edit status dropdown. */
export const PLAN_MANAGEMENT_STATUS_OPTIONS = [
  { value: "draft", label: "Draft" },
  { value: "to_do", label: "To Do" },
  { value: "in_progress", label: "In Progress" },
  { value: "testing", label: "Testing" },
  { value: "bug", label: "Bug" },
  { value: "ready_to_deploy", label: "Ready To Deploy" },
  { value: "done", label: "Done" },
  { value: "done_without_deploy", label: "Done without Deploy" },
  { value: "deployed", label: "Deployed" },
  { value: "hold", label: "Hold" },
  { value: "blocked", label: "Blocked" },
  { value: "cancel", label: "Cancel" },
  { value: "waiting_information", label: "Waiting Information" },
  { value: "waiting_support", label: "Waiting Support" },
];

/** Options for create/edit sub-project status dropdown. */
export const SUB_PROJECT_STATUS_OPTIONS = [
  { value: "draft", label: "Draft" },
  { value: "planning", label: "Planning" },
  { value: "waiting_planning", label: "Waiting Planning" },
  { value: "to_do", label: "To Do" },
  { value: "ready_to_test", label: "Ready To Test" },
  { value: "in_progress", label: "In Progress" },
  { value: "developing", label: "Developing" },
  { value: "developing_qa", label: "Developing QA" },
  { value: "qa_processing", label: "QA Processing" },
  { value: "ready_to_test_sit", label: "Ready To Test on SIT" },
  { value: "testing_on_sit", label: "Testing on SIT" },
  { value: "ready_to_test_stg", label: "Ready To Test on STG" },
  { value: "testing_on_stg", label: "Testing on STG" },
  { value: "waiting_to_deploy", label: "Waiting To Deploy" },
  { value: "ready_to_deploy", label: "Ready To Deploy" },
  { value: "done", label: "Done" },
  { value: "deployed", label: "Deployed" },
  { value: "block", label: "Block" },
  { value: "hold", label: "Hold" },
  { value: "cancel", label: "Cancel" },
];
